<p>user-groups-list-widget works!</p>
